import { Form as BaseForm } from 'components/Wizards/Form/Form'
import { SectionHeader } from 'components/Wizards/Wizard/Form/SectionHeader'
import { Field } from 'components/Wizards/Wizard/Form/Field'
import { CollapsibleSection } from 'components/Wizards/Wizard/Form/CollapsibleSection/CollapsibleSection'
import { useSections } from 'components/Wizards/Wizard/Form/Sections/SectionsProvider'
import { Field as BaseField } from 'components/Wizards/Field/Field'
import { PropsWithChildren, ReactNode } from 'react'

export const AdditionalFields = ({ fields, hideLabel = false }: { fields: [string, any][]; hideLabel?: boolean }) => (
  <>
    {fields.length > 0 && (
      <BaseField label={hideLabel ? undefined : 'More'}>
        {fields.map(([name, schema]) => (
          <Field key={name} name={name} schema={schema} />
        ))}
      </BaseField>
    )}
  </>
)

interface Props {
  isHeaderVisible?: boolean
  header?: ReactNode
}

export const AutoFillFieldsSection = ({ isHeaderVisible = true, header, children }: PropsWithChildren<Props>) => {
  const { isAutoFillSectionsEnabled, mainFields, collapsedFields, additionalFields, isAutocompleteEnabled } =
    useSections()

  return (
    <BaseForm.Section isDisabled={!isAutoFillSectionsEnabled}>
      {isAutocompleteEnabled && isAutoFillSectionsEnabled && isHeaderVisible && <SectionHeader />}
      <BaseForm.SectionContent>
        <BaseForm.Fields>
          {header}
          {mainFields.map(([name, schema], i) => (
            <Field key={name} name={name} schema={schema} autoFocus={i === 0} />
          ))}
          {children}
          {(collapsedFields.length > 0 || additionalFields.length > 0) && (
            <CollapsibleSection>
              {collapsedFields.map(([name, schema], i) => (
                <Field key={name} name={name} schema={schema} autoFocus={i === 0} />
              ))}

              <AdditionalFields fields={additionalFields} hideLabel={!collapsedFields.length} />
            </CollapsibleSection>
          )}
        </BaseForm.Fields>
      </BaseForm.SectionContent>
    </BaseForm.Section>
  )
}
